var Validators = window.Validators = (function() {
    function init() {
        registerRequiredIfValidator();
        registerRequiredBooleanValidator();
        registerIgnoreCaseComaprer();
        registerMaxDateValidator();
        registerMinDateValidator();
        registerMinValueValidator();
        registerMaxValueValidator();
        registerCreditCardValidator();
        registerDocTypeDependentNumberValidator();
        registerCheckMatchingValidator();
        registerConferenceIdentityIfValidator();
        customiseUnobtrusiveValidators();
        registerInnCheckSumValidator();
        registerSnilsCheckSumValidator();
    }

    function parse(element: any) {
        var jq: any = $;
        if (jq.validator && jq.validator.unobtrusive) {
            jq.validator.unobtrusive.parse(element);
        }
    }

    function creditCardLuhnCheck(val) {
        var sum = 0;
        for (var i = 0; i < val.length; i++) {
            var intVal = parseInt(val.substr(i, 1));
            if (i % 2 == 0) {
                intVal *= 2;
                if (intVal > 9) {
                    intVal = 1 + (intVal % 10);
                }
            }
            sum += intVal;
        }
        return (sum % 10) == 0;
    }

    function registerCreditCardValidator() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('creditcard',
            options => {
            });

        jq.validator.addMethod('creditcard',
            (value, element, parameters) => {
                value = value.replace(/[\s-_]/gm, '');

                return creditCardLuhnCheck(value);
            });
    }

    function tryParseDatepickerDate(element, value) {
        if ($.datepicker && $(element).attr('datepicker-dateformat')) {
            var format = $(element).attr('datepicker-dateformat');
            var dt = null;
            try {
                dt = $.datepicker.parseDate(format, value);

                if (!/Invalid|NaN/.test(dt.toString())) {
                    return { date: dt, valid: true };
                }
            } catch (e) {
            }

            return { valid: false };
        }
    }

    function isDate(element, value) {
        return tryParseDatepickerDate(element, value).valid;
    }

    function registerMinValueValidator() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('minvalue',
            ['min'],
            options => {
                options.rules['min'] = options.params;
                options.messages['min'] = options.message;
            });

        jq.validator.addMethod('min',
            (value, element, parameters) => {
                if ($.isNumeric(value)) {
                    try {
                        var val = parseFloat(value);
                        var min = parseFloat(parameters.min);

                        return val >= min;
                    } catch (err) {
                    }

                    return false;
                } else if (isDate(element, value)) {
                    var date = tryParseDatepickerDate(element, value).date;
                    var minDate = tryParseDatepickerDate(element, parameters).date;

                    return date >= minDate;
                }
            });
    }

    function registerMaxValueValidator() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('maxvalue',
            ['max'],
            options => {
                options.rules['max'] = options.params;
                options.messages['max'] = options.message;
            });

        jq.validator.addMethod('max',
            (value, element, parameters) => {
                if ($.isNumeric(value)) {
                    try {
                        var val = parseFloat(value);
                        var max = parseFloat(parameters.max);

                        return val <= max;
                    } catch (err) {
                    }

                    return false;
                } else if (isDate(element, value)) {
                    var date = tryParseDatepickerDate(element, value).date;
                    var minDate = tryParseDatepickerDate(element, parameters).date;

                    return date <= minDate;
                }
            });
    }

    function registerRequiredBooleanValidator() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('requiredbool',
            ['value'],
            options => {
                options.rules['requiredbool'] = options.params;
                options.messages['requiredbool'] = options.message;
            });

        jq.validator.addMethod('requiredbool',
            (value, element, parameters) => {
                var expectedValue: any = parameters.value.toString().toLowerCase();
                var val: any = null;
                if (element.type == 'checkbox') {
                    val = $(element).is(':checked');
                } else {
                    val = $(element).val();
                }

                val = val.toString().toLowerCase();

                return val == expectedValue;
            });
    }

    function registerDocTypeDependentNumberValidator() {
        var jq: any = $;

        jq.validator.unobtrusive.adapters.add('doctypedependency',
            ['dependentproperty', 'mainproperty'],
            options => {
                options.rules['doctypedependency'] = options.params;
                options.messages['doctypedependency'] = options.message;
                var dependentProperty: any = $('#' + options.params.dependentproperty);
                dependentProperty.change(function () {
                    var validator = jq(options.form).validate();
                    validator.element(options.element);
                });
            });

        jq.validator.addMethod('doctypedependency',
            function (value, element, parameters) {
                var selectedType = $('#DocType').val();

                var toCheck = value.replace(/ /g, "");

                if (selectedType == 'RussianPassport' && $('#ShouldEnterPersonalData').val() == 'True') {
                    if (parameters.mainproperty == 'DocumentSeries' || parameters.mainproperty == 'DocSeries')
                        return toCheck.match(/^\d{4}$/);
                    else
                        return toCheck.match(/^\d{6}$/);
                }

                return true;
            });
    }

    function registerRequiredIfValidator() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('requiredif',
            ['dependsonproperties', 'dependsonvalues', 'requiredvalue'],
            options => {
                options.rules['requiredif'] = options.params;
                options.messages['requiredif'] = options.message;

                var dependsOnProperties = JSON.parse(options.params.dependsonproperties)
                if (dependsOnProperties) {
                    for (var i = 0; i < dependsOnProperties.length; i++) {
                        var dependesOnProperty: any = $('#' + dependsOnProperties[i]);
                        dependesOnProperty.change(function () {
                            var validator = jq(options.form).validate();
                            validator.element(options.element);
                        });
                    }
                }
            });

        jq.validator.addMethod('requiredif',
            function (value, element, parameters) {
                let dependsOnProperties = JSON.parse(parameters.dependsonproperties)
                let shouldValidate = true;
                if (dependsOnProperties?.length) {
                    var dependsOnValues = JSON.parse(parameters.dependsonvalues);
                    if (dependsOnValues?.length) {
                        dependsOnValues = dependsOnValues.map((val) => { return val == null ? '' : val.toString().trim().toLowerCase() });
                        for (let i = 0; i < dependsOnProperties.length; i++) {
                            let controlType = $("input[id$='" + dependsOnProperties[i] + "']").attr("type");
                            let actualValue = null;

                            if (controlType == "checkbox" || controlType == "radio") {
                                let control = $("input[id$='" + dependsOnProperties[i] + "']:checked");
                                actualValue = control.val();
                            } else {
                                actualValue = $("#" + dependsOnProperties[i]).val();
                            }
                            actualValue = $.trim(actualValue).toLocaleLowerCase()

                            let dependentValueMatches = false;
                            for (let vInd = 0; vInd < dependsOnValues.length; vInd++) {
                                if (dependsOnValues[vInd] === actualValue) {
                                    dependentValueMatches = true;
                                    break;
                                }
                            }
                            if (!dependentValueMatches) {
                                shouldValidate = false;
                                break;
                            }
                        }
                    }
                }

                if(shouldValidate)
                    return parameters.requiredvalue == ''
                        ? jq.validator.methods.required.call(this, value, element, parameters)
                        : value == parameters.requiredvalue;

                return true;
            });
    }

    function registerCheckMatchingValidator() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('checkmatching', ['validationattributename', 'userinputattributename'],
            options => {
                options.rules['checkmatching'] = options.params;
                options.messages['checkmatching'] = options.message;
                var validationattributename: any = jq('[name^=' + options.params.validationattributename + ']');
                validationattributename.bind('input', function () {
                    var validator = jq(options.form).validate();
                    validator.element(options.element);
                });
            });

        jq.validator.addMethod('checkmatching',
            function (value, element, parameters) {
                if (value) {
                    var allBets = jq('[name$=' + parameters.validationattributename + ']');
                    if (allBets && allBets.length > 1) {
                        var otherBets = allBets.filter(function (idx, elm) {
                            return elm.id != element.id;
                        });
                        jq('#' + element.id + '+[name$=' + parameters.userinputattributename + ']').val(otherBets.map(function () {
                            return jq(this).val();
                        }).toArray().join('|'));

                        return !otherBets.filter(function (idx, elm) {
                            return jq(elm).val() == value;
                        }).length;
                    }
                }

                return true;
            });
    }

    function registerConferenceIdentityIfValidator() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('conferenceidentityif',
            ['dependentproperty', 'regexppattern', 'maxlengthskypelogin', 'maxlengtherrormessage', 'phonepatternerrormessage'],
            options => {
                options.rules['conferenceidentityif'] = options.params;
                var dependentProperty: any = $('[name$=' + options.params.dependentproperty + ']');
                dependentProperty.change(function () {
                    var validator = jq(options.form).validate();
                    validator.element(options.element);
                });
            });

        jq.validator.addMethod('conferenceidentityif',
            function (value, element, parameters) {
                var conferenceType = $('[name$=' + parameters.dependentproperty + ']').val();
                switch (conferenceType) {
                    case "Viber":
                    case "Whatsapp":
                        jq.validator.messages['conferenceidentityif'] = parameters.phonepatternerrormessage;
                        return !!jq.validator.methods.regex.call(this, value, element, new RegExp(parameters.regexppattern));
                    case "Skype":
                        jq.validator.messages['conferenceidentityif'] = parameters.maxlengtherrormessage;
                        return jq.validator.methods.maxlength.call(this, value, element, parameters.maxlengthskypelogin);
                }
                return false;
            });
    }

    function registerIgnoreCaseComaprer() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('ignorecasecompare',
            ['dependentproperty'],
            options => {
                options.rules['ignorecasecompare'] = options.params;
                options.messages['ignorecasecompare'] = options.message;


                var dependentProperty: any = $('#' + options.params.dependentproperty);
                dependentProperty.change(function () {
                    var validator = jq(options.form).validate();
                    validator.element(options.element);
                });
            });


        jq.validator.addMethod('ignorecasecompare',
            (value, element, parameters) => {
                var dependent = $("input[id$='" + parameters.dependentproperty + "']");
                return (dependent.val().toUpperCase() === value.toUpperCase())
            });
    }

    function registerMaxDateValidator() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('maxdate',
            ['relativeyears', 'isnullvalid'],
            options => {
                options.rules['maxdate'] = options.params;
                options.messages['maxdate'] = options.message;
            });

        jq.validator.addMethod('maxdate',
            (value, element, parameters) => {

                var isNullValid = parameters.isnullvalid;

                if (value == '' && isNullValid) return true;

                var d = tryParseDatepickerDate(element, value);
                if (d.valid) {
                    var actualDate = new Date();
                    var targetDate = new Date(actualDate.getFullYear() + parseInt(parameters.relativeyears),
                        actualDate.getMonth(),
                        actualDate.getDate());


                    return d.date <= targetDate;
                }

                return false;
            });
    }

    function registerMinDateValidator() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('mindate',
            ['relativeyears', 'isnullvalid'],
            options => {
                options.rules['mindate'] = options.params;
                options.messages['mindate'] = options.message;
            });

        jq.validator.addMethod('mindate',
            (value, element, parameters) => {

                var isNullValid = parameters.isnullvalid;

                if (value == '' && isNullValid) return true;

                var d = tryParseDatepickerDate(element, value);
                if (d.valid) {
                    var actualDate = new Date();
                    var targetDate = new Date(actualDate.getFullYear() + parseInt(parameters.relativeyears),
                        actualDate.getMonth(),
                        actualDate.getDate());

                    return d.date >= targetDate;
                }

                return false;
            });
    }

    function validateDate(value, element) {
        if ($.datepicker && $(element).attr('datepicker-dateformat')) {
            var format = $(element).attr('datepicker-dateformat');
            var dateValid = false;
            var dt = null;
            try {
                dt = $.datepicker.parseDate(format, value);
                dateValid = true;
            } catch (e) {
            }

            return this.optional(element) || (dateValid && !/Invalid|NaN/.test(dt.toString()));
        }
        if ((<any>$).timepicker && $.datepicker) {
            var timeFormat = 'HH:mm:ss',
                dateFormat = 'dd.mm.yy',
                dateValid = false,
                dt = null;
            try {
                dt = (<any>$.datepicker).parseDateTime(dateFormat, timeFormat, value);
                dateValid = true;
            } catch (e) {
            }

            return this.optional(element) || (dateValid && !/Invalid|NaN/.test(dt.toString()));
        }
        return this.optional(element) || !/Invalid|NaN/.test(new Date(value).toString());
    }

    function customiseUnobtrusiveValidators() {
        var jq: any = $;
        jq.validator.prototype.customDataMessage = function (element, method) {
            var dataUpperCasedName = "msg" + method.charAt(0).toUpperCase() + method.substring(1).toLowerCase();
            var dataLowerCasedName = "msg" + method.toLowerCase();

            return $(element).data(dataUpperCasedName) || $(element).data(dataLowerCasedName) || $(element).data("msg");
        };

        if (jq.validator) {
            jq.validator.methods.date = validateDate;
            jq.validator.setDefaults(
                {
                    ignore: null,
                }
            );
        }
    }

    function registerInnCheckSumValidator() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('innchecksum',
            options => {
                options.rules['innchecksum'] = options.params;
                options.messages['innchecksum'] = options.message;
            });

        jq.validator.addMethod('innchecksum',
            (value, element, parameters) => {
                if (value) {
                    const coefsFor11 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
                    const coefsFor12 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
                    let dgt11: number;
                    let dgt12: number;

                    try {
                        dgt11 = getCheckNumber(value, coefsFor11);
                        dgt12 = getCheckNumber(value, coefsFor12);
                    } catch (e) {
                        return false;
                    }
                    return parseInt(value[10]) == dgt11 && parseInt(value[11]) == dgt12;
                }
                return true;
            });
    }

    function getCheckNumber(innString, checkSumCoefs) {
        let checkNumber = 0;
        for (var i = 0; i < checkSumCoefs.length; i++) {
            checkNumber += parseInt(innString[i]) * checkSumCoefs[i];
        }

        return (checkNumber % 11) % 10;
    }



    function registerSnilsCheckSumValidator() {
        var jq: any = $;
        jq.validator.unobtrusive.adapters.add('snilschecksum',
            options => {
                options.rules['snilschecksum'] = options.params;
                options.messages['snilschecksum'] = options.message;

            });

        jq.validator.addMethod('snilschecksum',
            (value, element, parameters) => {
                if (value) {
                    let numbersOnly = value.toString().replace(/\D/g, '');
                    if (numbersOnly.length != 11)
                        return false;

                    if (parseInt(numbersOnly.substring(0, 9)) <= 1001998)
                        return true;

                    let checkSum = parseInt(numbersOnly.substring(9));
                    let sum = 0;
                    for (let i = 1; i < 10; i++)
                        sum += i * parseInt(numbersOnly[9 - i]);

                    if (sum > 101)
                        sum %= 101;

                    return sum < 100 ? sum == checkSum : sum == 0;
                }
                return true;
            });
    }

    return {
        init,
        parse
    }
}());